import { Vue, Component } from 'vue-property-decorator';

@Component
export default class CustomerActivitySettings extends Vue {

	readonly customerExpireInMinutes: number = Number(process.env.VUE_APP_SESSION_EXPIRATION || 5);

	readonly customerExpireAlertInMinutes: number = 4;

	readonly customerExpireAlertShowInMinutes: number = 1;

}
